import axios from "axios";

export const decentralized = axios.create({
  baseURL: process.env.VUE_APP_DECENTRALIZED,
  // timeout: 2000,
  headers: {
    "Access-Control-Allow-Origin": process.env.VUE_APP_DECENTRALIZED,
  },
});

export const products = axios.create({
  baseURL: process.env.VUE_APP_PRODUCT,
  // timeout: 2000,
  headers: {
    "Access-Control-Allow-Origin": process.env.VUE_APP_PRODUCT,
  },
});

export const product_file = axios.create({
  baseURL: process.env.VUE_APP_PRODUCT,
  headers: {
    Accept: "multipart/form-data",
    "Access-Control-Allow-Origin": process.env.VUE_APP_PRODUCT,
  },
});

export const store = axios.create({
  baseURL: process.env.VUE_APP_STORE,
  // timeout: 2000,
  headers: {
    "Access-Control-Allow-Origin": process.env.VUE_APP_STORE,
  },
});

export const store_file = axios.create({
  baseURL: process.env.VUE_APP_STORE,
  headers: {
    Accept: "multipart/form-data",
    "Access-Control-Allow-Origin": process.env.VUE_APP_STORE,
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
});

export const users = axios.create({
  baseURL: process.env.VUE_APP_USERS,
  // timeout: 2000,
  headers: {
    "Access-Control-Allow-Origin": process.env.VUE_APP_STORE,
  },
});
